import { Container, Row, Col } from 'react-bootstrap';

const FormContainer = ({ children, colProps = { xs: 12, md: 6 } }) => {
  return (
    <Container>
       <Row className="justify-content-md-center">
          <Col {...colProps}>
            { children }
          </Col>
       </Row> 
    </Container>
  );
};
export default FormContainer;
